export default __webpack_public_path__ + "static/media/webflow.d8a7c8dc.svg";